<template>
  <div class="middle-box text-center loginscreen animated fadeInDown">
    <div>
      <div>
        <img style="margin-bottom: 50px" src="/static/logo-my-emateriel.svg" />
      </div>
      <b-alert show variant="danger" v-html="message"></b-alert>

      <p>
        <router-link :to="{ name: 'Home' }">Retourner au Dashboard</router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Unauthorized",
  computed: {
    message() {
      if (this.$route.name == "UnauthorizedWithMessage" && this.$route.params.message) {
        if (this.$route.params.message == "wrong_or_expired_token") {
          return "Votre jeton de connexion n'est pas correct, veuillez retourner au Dashboard pour vous authentifier de nouveau.";
        } else if (this.$route.params.message == "no_user_email_in_token") {
          return "Azure ne nous a retourné aucune adresse email. Il nous est impossible de vous authentifier. Veuillez prendre contact avec votre service Azure.";
        } else if (this.$route.params.message == "azure_user_email_not_found_in_database") {
          return "Vous n'êtes pas autorisé à accéder à cette application. Pour toute information veuillez prendre contact avec <a href='mailto:logistique.axima@equans.com'>logistique.axima@equans.com</a>";
        } else if (this.$route.params.message == "no_employee_associate_in_token") {
          return "Aucun utilisateur associé à ce GID n'a été trouvé. Pour toute information veuillez prendre contact avec <a href='mailto:logistique.axima@equans.com'>logistique.axima@equans.com</a>";
        }
      }
      return "Vous ne possédez pas les autorisations nécessaires pour accéder au contenu demandé.";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Security/unauthorized.vue